module.exports = __webpack_public_path__ + "static/img/43-100.932fd07.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/video-slider/43-100.jpg
// module id = yfn2
// module chunks = 2